import { ConfigService } from '../../../infra/config'
import { BaseRepository } from '../../../infra/base.repository'
import type { List } from './list'
import type { MoveListDto } from './lists-move.dto'

export class ListsRepository extends BaseRepository<List> {
    constructor(
        private endpoint: string,
        private config: ConfigService = new ConfigService(),
        token?: string,
        cache?: any,
    ) {
        if (!endpoint) throw new Error('Constructor param required')

        super(config.pipelineApiUrl + '/' + endpoint, token, cache)
    }

    async move(listId: string, dto: MoveListDto) {
        const { json, statusCode, message } = await this.request.put(
            this.config.pipelineApiUrl +
                '/' +
                this.endpoint +
                '/' +
                listId +
                '/?token=' +
                this.resolvedToken,
            dto,
        )
        if (String(statusCode).substring(0, 1) === '2') return
        throw message
    }

    async resetToken(listId: string) {
        const { json, statusCode, message } = await this.request.post(
            this.config.pipelineApiUrl +
                '/' +
                this.endpoint +
                '/' +
                listId +
                '/reset-token?token=' +
                this.resolvedToken,
            {},
        )
        if (String(statusCode).substring(0, 1) === '2') return
        throw message
    }
}
